var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessOrderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30800_175273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0012 24.0024C5.37614 23.9951 0.00727557 18.6263 0 12.0012V11.7612C0.131931 5.16597 5.56206 -0.0864395 12.158 0.00107797C18.754 0.0885954 24.0428 5.48323 23.9997 12.0796C23.9566 18.676 18.5977 24.0011 12.0012 24.0024ZM7.19975 12.2135C6.80901 11.8243 6.1769 11.8249 5.78691 12.2149L5.50759 12.4942C5.11706 12.8848 5.11706 13.5179 5.50759 13.9084L8.89385 17.2947C9.28438 17.6852 9.91754 17.6852 10.3081 17.2947L18.4973 9.10547C18.8869 8.71592 18.888 8.08469 18.4998 7.69376L18.2168 7.4088C17.8267 7.01592 17.1916 7.0148 16.8001 7.4063L9.60096 14.6055L7.19975 12.2135Z",
    fill: "#00AB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0012 24.0024C5.37614 23.9951 0.00727557 18.6263 0 12.0012V11.7612C0.131931 5.16597 5.56206 -0.0864395 12.158 0.00107797C18.754 0.0885954 24.0428 5.48323 23.9997 12.0796C23.9566 18.676 18.5977 24.0011 12.0012 24.0024ZM7.19975 12.2135C6.80901 11.8243 6.1769 11.8249 5.78691 12.2149L5.50759 12.4942C5.11706 12.8848 5.11706 13.5179 5.50759 13.9084L8.89385 17.2947C9.28438 17.6852 9.91754 17.6852 10.3081 17.2947L18.4973 9.10547C18.8869 8.71592 18.888 8.08469 18.4998 7.69376L18.2168 7.4088C17.8267 7.01592 17.1916 7.0148 16.8001 7.4063L9.60096 14.6055L7.19975 12.2135Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30800_175273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOrderIcon);
export default __webpack_public_path__ + "static/media/success-order-icon.ac9e29ded7fd7b3d9b9635321343b715.svg";
export { ForwardRef as ReactComponent };